/**
 * Loose null checking.
 * @param input checks input of type string and number for nullish or 0 value
 * @param defaultValue optional: returns this value if specified
 * @returns a string containing "Ingen" or the specified defaultValue
 */
export const defaultIfNullish = (
  input: string | number | boolean | undefined | null,
  defaultValue?: string,
) => {
  return input ? `${input}` : (defaultValue ?? "-");
};
